import styled from "styled-components";

export const FormInput = styled.input`
    width: 350px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid transparent;
    background-color: #F5F5F5;
  
  &:focus{
    outline: none;
  }
`;